"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var widthMobile = "50px";
var widthDesktop = "64px";

var StyledTitleBlock = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n\n  text-align: ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n    max-width: ", ";\n    min-width: ", ";\n  }\n"])), widthMobile, widthMobile, widthMobile, function (p) {
  return p.isCentered ? "center" : "left";
}, function (props) {
  return props.theme.screenWidthMd;
}, widthDesktop, widthDesktop, widthDesktop);

var StyledTitleBlockLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 0.575rem;\n  opacity: 0.5;\n  white-space: nowrap;\n"])));

var StyledTitleBlockValue = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  margin-bottom: 2px;\n"])));

var Wrapper = function Wrapper(_ref) {
  var label = _ref.label,
      value = _ref.value,
      isMoney = _ref.isMoney,
      isCentered = _ref.isCentered;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTitleBlock, {
    isCentered: isCentered,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitleBlockValue, {
      children: isMoney ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.PenceToPounds, {
        showCurrencySymbol: true,
        children: value
      }) : value
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitleBlockLabel, {
      children: label
    })]
  });
};

var _default = Wrapper;
exports.default = _default;